import { drawing } from '@progress/kendo-drawing';
import { isFunction, defined } from '../utils/functions.js';
import '../math/Graph.js';
import { Rect } from '../math/Shapes.js';

class Canvas {
    constructor(element, options) {
        options = options || {};
        this.element = element;
        this.surface = drawing.Surface.create(element, options);
        if (isFunction(this.surface.translate)) {
            this.translate = this._translate.bind(this);
        }
        this.drawingElement = new drawing.Group();
        this._viewBox = new Rect(0, 0, options.width, options.height);
        this.size(this._viewBox);
    }
    bounds() {
        const box = this.drawingElement.clippedBBox();
        return new Rect(0, 0, box.width(), box.height());
    }
    size(size) {
        const viewBox = this._viewBox;
        if (defined(size)) {
            viewBox.width = size.width;
            viewBox.height = size.height;
            this.surface.setSize(size);
        }
        return {
            width: viewBox.width,
            height: viewBox.height
        };
    }
    _translate(x, y) {
        const viewBox = this._viewBox;
        if (defined(x) && defined(y)) {
            viewBox.x = x;
            viewBox.y = y;
            this.surface.translate({ x: x, y: y });
        }
        return {
            x: viewBox.x,
            y: viewBox.y
        };
    }
    draw() {
        this.surface.draw(this.drawingElement);
    }
    append(visual) {
        this.drawingElement.append(visual.drawingContainer());
        return this;
    }
    remove(visual) {
        this.drawingElement.remove(visual.drawingContainer());
    }
    insertBefore() { }
    clear() {
        this.drawingElement.clear();
    }
    destroy(clearHtml) {
        this.surface.destroy();
        if (clearHtml) {
            this.element.remove();
        }
    }
}

export { Canvas };
